module.exports = __webpack_public_path__ + "static/media/thinker.847455f5.webp";